import Vue from "vue";
import TrendChart from "vue-trend-chart";

Vue.use(TrendChart);